var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#0093ED"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.997 19.2362L23.2346 13.9988C23.3785 13.8546 23.5709 13.7753 23.776 13.7753C23.9812 13.7753 24.1734 13.8546 24.3175 13.9988L24.7762 14.4578C24.9206 14.6017 25 14.7942 25 14.9993C25 15.2044 24.9206 15.3967 24.7762 15.5408L18.5404 21.7767C18.3959 21.9213 18.2027 22.0006 17.9974 22C17.7911 22.0006 17.5982 21.9215 17.4535 21.7767L11.2238 15.5466C11.0794 15.4025 11 15.2102 11 15.005C11 14.7999 11.0794 14.6077 11.2238 14.4634L11.6825 14.0046C11.981 13.7061 12.467 13.7061 12.7655 14.0046L17.997 19.2362Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.f37c2aec22dee65633a8867b10879299.svg";
export { ForwardRef as ReactComponent };